import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { TRADABLE_PRECISION } from "@modules/staking/domain/entities/constants";
import { getCurrentDecimalSeperator } from "./utils";

@Directive({
	selector: "input[limitDecimalToCurrency]",
	standalone: false
})
export class LimitDecimalToCurrencyDirective {
	@Input() displayTradable: boolean = true;
	@Input() assetPrecision: number = TRADABLE_PRECISION;
	@Input() fiatPrecision: number = 2;

	constructor(private _el: ElementRef) {}

	@HostListener("input", ["$event"]) onInputChange(event): void {
		const value = this._el.nativeElement.value;
		const decimalSeperator = getCurrentDecimalSeperator();
		const precision = this.displayTradable ? this.assetPrecision : this.fiatPrecision;
		if (value.indexOf(decimalSeperator) !== -1) {
			const [intiger, decimals] = value.split(getCurrentDecimalSeperator());
			if (decimals.length > precision) {
				this._el.nativeElement.value = intiger + decimalSeperator + decimals.slice(0, precision);
				event.stopPropagation();
			}
		}
	}
}
